import React, { useState } from "react";

const VivahDakhala = () => {
  const [records, setRecords] = useState([]);
  const [formData, setFormData] = useState({
    brideName: "",
    groomName: "",
    marriageDate: "",
    marriagePlace: "",
    certificateNumber: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.brideName || !formData.groomName || !formData.marriageDate) {
      alert("कृपया आवश्यक माहिती भरा.");
      return;
    }

    setRecords([...records, { ...formData }]);

    setFormData({
      brideName: "",
      groomName: "",
      marriageDate: "",
      marriagePlace: "",
      certificateNumber: "",
    });
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>विवाह दाखला (Marriage Certificate)</h2>
      <p style={styles.description}>येथे विवाह प्रमाणपत्राची नोंद केली जाते.</p>

      {/* Form */}
      <form style={styles.form} onSubmit={handleSubmit}>
        <input
          type="text"
          name="brideName"
          placeholder="वधूचे नाव"
          value={formData.brideName}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <input
          type="text"
          name="groomName"
          placeholder="वराचे नाव"
          value={formData.groomName}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <input
          type="date"
          name="marriageDate"
          value={formData.marriageDate}
          onChange={handleChange}
          style={styles.input}
          required
        />
        <input
          type="text"
          name="marriagePlace"
          placeholder="विवाहाचे ठिकाण"
          value={formData.marriagePlace}
          onChange={handleChange}
          style={styles.input}
        />
        <input
          type="text"
          name="certificateNumber"
          placeholder="प्रमाणपत्र क्रमांक"
          value={formData.certificateNumber}
          onChange={handleChange}
          style={styles.input}
        />

        <button type="submit" style={styles.button}>नोंद जोडा</button>
      </form>

      {/* Records */}
      <div style={styles.listContainer}>
        <h3>📜 नोंदवलेले विवाह दाखले:</h3>
        {records.length === 0 ? (
          <p>अजून कोणतीही नोंद नाही.</p>
        ) : (
          <ul style={styles.list}>
            {records.map((record, index) => (
              <li key={index} style={styles.listItem}>
                <strong>{record.brideName} & {record.groomName}</strong> —
                {" "}{record.marriageDate} — {record.marriagePlace} — {record.certificateNumber}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f9f9f9",
    padding: "20px",
    minHeight: "100vh",
  },
  title: {
    color: "#005A8D",
    textAlign: "center",
  },
  description: {
    textAlign: "center",
    marginBottom: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "400px",
    margin: "0 auto",
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0 0 8px rgba(0,0,0,0.2)",
  },
  input: {
    padding: "8px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  button: {
    backgroundColor: "#005A8D",
    color: "#fff",
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  listContainer: {
    marginTop: "30px",
  },
  list: {
    listStyle: "none",
    paddingLeft: 0,
  },
  listItem: {
    backgroundColor: "#fff",
    padding: "10px",
    marginBottom: "8px",
    borderRadius: "5px",
    boxShadow: "0 0 4px rgba(0,0,0,0.1)",
  },
};

export default VivahDakhala;